import { defineComponent as _defineComponent } from 'vue'
import BreadCrumbComponent from "@/components/bread-crumb-component.vue";
import AssessmentInstruction from "@/components/assessment-instruction-item-component.vue";
import Loading from "@/components/loading.vue";
import { Ref, computed, ref, onMounted } from "vue";
import useHttpRequest from "@/composables/use-http-request";
import { useRoute, useRouter } from "vue-router/composables";
import CourseWork from "@/interfaces/courseWork.interface";
import StartCourseWorkComponent from "@/components/start-course-work-component.vue";
import OnlineAnswersheetInfoDialog from "@/components/dialogs/online-answersheet-info-dialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'coursework-instructions',
  setup(__props) {

const isLoading = ref(true);
const courseWork: Ref<CourseWork | undefined> = ref();
const route = useRoute();
const router = useRouter();

const onlineAnswersheetInfoDialogVisible = ref(false);

const getCourseWorkInstructions = async () => {
  const request = await useHttpRequest<{
    success: boolean;
    course_work: CourseWork;
    message: string;
  }>({
    method: "GET",
    url: `course-work/fetch-course-work-instructions/${
      route.params.courseWorkId
    }?timestamp=${new Date().getTime()}`,
    loadingProperty: isLoading,
    showSuccessMessage: false,
    errorLoadingProperty: null,
  });

  if (!request) {
    router.replace({ path: "/dashboard/course-works" });
    return;
  }
  if (
    request.success &&
    request.message == "Course work instructions fetched successfully"
  ) {
    courseWork.value = request.course_work;

    //if the student has not started the exam yet, show the online answersheet dialog
    if (!courseWork.value?.student_course_work_submissions?.length) {
      setTimeout(() => {
        onlineAnswersheetInfoDialogVisible.value = true;
      }, 500);
    }
  } else {
    router.replace({ path: "/dashboard/course-works" });
  }
};

/* 
  Since the course work may be on multiple intakes, then we need to avoid showing all modules on this course work
  as it may confuse the student i.e only show the one they clicked on the previous page and hide all the rest
*/
const userChosenModule = computed((): string => {
  let chosenModule = courseWork.value?.course_work_intakes?.find(
    (intake) => intake.course_unit_id == route.params.courseUnitId
  );
  return chosenModule
    ? `${chosenModule.course_unit.course_unit_code} - ${chosenModule.course_unit.title}`
    : "";
});

onMounted(() => {
  getCourseWorkInstructions();
});

return { __sfc: true,isLoading, courseWork, route, router, onlineAnswersheetInfoDialogVisible, getCourseWorkInstructions, userChosenModule, BreadCrumbComponent, AssessmentInstruction, Loading, StartCourseWorkComponent, OnlineAnswersheetInfoDialog }
}

})